import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import NotFoundView from './components/404.vue'

// Import Views - Dash
import DashboardView from './components/views/Dashboard.vue'
import MaquinasView from './components/views/Maquinas.vue'
import TurnosView from './components/views/Turnos.vue'
import RelatoriosGeraisView from './components/views/RelatoriosGerais.vue'
import RelatoriosProducaoView from './components/views/RelatoriosProducao.vue'
import RelatoriosProducaoTagView from './components/views/RelatoriosProducaoTag.vue'
import RelatoriosTagView from './components/views/RelatoriosTag.vue'
import RelatoriosProducaoPedidosTempo from './components/views/RelatoriosProducaoPedidosTempo.vue'

// Routes
const routes = [
  {
    path: '/login',
    component: LoginView
  },
  {
    path: '/',
    component: DashView,
    children: [
      {
        path: 'dashboard',
        alias: '',
        component: DashboardView,
        name: 'Painel',
        meta: {description: 'Resumo das Máquinas'}
      }, {
        path: 'maquinas',
        component: MaquinasView,
        name: 'Máquinas',
        meta: {description: 'Configuração das Máquinas'}
      }, {
        path: 'relatorios-gerais',
        component: RelatoriosGeraisView,
        name: 'Relatórios Gerais',
        meta: {description: 'Visualização concentrada de todos relatórios'}
      }, {
        path: 'relatorios-producao',
        component: RelatoriosProducaoView,
        name: 'Percentual de Operação',
        meta: {description: 'Relatório de percentual de tempo em operação por período'}
      }, {
        path: 'relatorios-producao-tag',
        component: RelatoriosProducaoTagView,
        name: 'Relatório de Produção',
        meta: {description: 'Relatório de total produzido por período'}
      }, {
        path: 'relatorios-producao-Desempenho',
        component: RelatoriosProducaoPedidosTempo,
        name: 'Relatório de Desempenho',
        meta: {description: 'Relatório Geral de Desempenho'}
      }, {
        path: 'relatorios-tag',
        component: RelatoriosTagView,
        name: 'Relatório Por Código',
        meta: {description: 'Relatório de desempenho por código'}
      }, {
        path: 'turnos',
        component: TurnosView,
        name: 'Turnos',
        meta: {description: 'Período de Produção das Máquinas'}
      }
    ]
  }, {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js